import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./libraries";
import "./directives/v-closable";
import appPlugins from "./helpers/plugins";
import localStorage from "./helpers/localStorage";

if (localStorage.get("APP_VERSION") === false) {
  localStorage.clearAll();
  localStorage.set("APP_VERSION", "4.1");
}

Vue.config.productionTip = false;
Vue.use(appPlugins);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
